export default class Responsive {
    static isMobile = () => $(window).width() < 768;
    static isTablet = () => $(window).width() >= 768 && $(window).width() <= 1024;
}



// WEBPACK FOOTER //
// ./js/mywort/commons/utils/Responsive.js